export const INSTANCE_CONFIG_QUERY_KEY = "instanceConfig" as const;
